// =============================================================================
// PLAFOND DE REDEVANCE — la promesse publique et le moteur lisent le MÊME chiffre
// =============================================================================
// Arbitrage d'Eliott du 06/10/2026 (KST-2084) : « sur remup rdv d'ailleurs c'est
// 80k aussi ». Depuis KST-1933 (05/10/2026), la redevance est plafonnée à
// 80 000 € par société qui exploite la marque, et à 80 000 € au plus par associé
// qui la perçoit (`apps/valorup-app/src/lib/fiscal.ts`, `calculerPlafondRegime`).
//
// Le site remup.fr promettait encore « jusqu'à 83 600 €/an » : ce chiffre est le
// SEUIL DE RECETTES du régime micro-BIC (art. 50-0 CGI, 2026-2028), un fait
// légal — pas notre plafond. Les deux coexistent et ne doivent pas se confondre :
//   • 83 600 € : ce que la loi permet d'encaisser en micro-BIC ;
//   • 80 000 € : ce que RemUp recommande au plus, volontairement en deçà, et ce
//     que le site peut promettre.
//
// Une seule source, lue par le moteur (valorup-app), par remup.fr (`CHIFFRES`)
// et par valorup.fr. Un test balaie chaque site et refuse qu'une promesse
// recopie l'ancienne valeur (`.claude/rules/chiffre-unique.md`).
// =============================================================================

/** Plafond annuel de redevance par société exploitante (et par associé), en euros. */
export const PLAFOND_REDEVANCE_PAR_SOCIETE = 80_000;

/**
 * Seuil de recettes du régime micro-BIC, prestations de services (art. 50-0 CGI) :
 * 83 600 € pour 2026, 2027 et 2028 (loi de finances pour 2026, n° 2026-103).
 * ⚠️ Périmé au 01/01/2029. C'est un FAIT LÉGAL, pas notre plafond : le site le
 * cite pour décrire le régime, jamais pour promettre un revenu. Le moteur
 * (`fiscal.ts`, `SEUIL_MICRO_BIC_LEGAL`) et les textes des sites le lisent ici.
 */
export const SEUIL_MICRO_BIC_RECETTES = 83_600;
/** « 83 600 », même graphie que le plafond. */
export const SEUIL_MICRO_BIC_AFFICHE = String(SEUIL_MICRO_BIC_RECETTES).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

/**
 * « 80 000 » — milliers séparés d'une espace simple (jamais insécable : c'est la
 * graphie de tout le site), sans dépendre d'ICU (Workers, Node, navigateur).
 */
export const PLAFOND_REDEVANCE_NOMBRE = String(PLAFOND_REDEVANCE_PAR_SOCIETE).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

/** La même valeur, écrite comme le site l'affiche : « 80 000€ », euro collé. */
export const PLAFOND_REDEVANCE_AFFICHE = `${PLAFOND_REDEVANCE_NOMBRE}€`;

/**
 * À QUI le plafond s'applique — arbitrage d'Eliott du 06/10/2026 (KST-2084, suite) :
 * « par société ou marque exploitée », jamais « par associé ». Une société à deux
 * associés ne verse pas 160 000 € : « jusqu'à 80 000 €/an et par associé » promettait
 * le double. Trois formes, une seule famille : la longue pour les promesses, la courte
 * pour les encarts, celle de la marque quand la phrase parle déjà de la marque.
 */
export const PLAFOND_REDEVANCE_PORTEE = 'par société exploitant la marque';
export const PLAFOND_REDEVANCE_PORTEE_COURTE = 'par société';
export const PLAFOND_REDEVANCE_PORTEE_MARQUE = 'par marque exploitée';

/** Version courte pour les encarts et les badges : « 80k€ ». */
export const PLAFOND_REDEVANCE_COURT = `${PLAFOND_REDEVANCE_PAR_SOCIETE / 1000}k€`;
